<div class="side-top">
    <button class="btn newchat btn-primary" type="button" (click)="newChatRequested.emit()">
        <i class="bi bi-plus-lg" aria-hidden="true"></i> New chat
    </button>
    <div class="search-wrap input-group">  
        <span class="input-group-text">
            <i class="bi bi-search start-0 translate-middle-y my-auto align-items-center" aria-hidden="true" id="search-addon"></i>
        </span>
        <label class="visually-hidden" for="conversationSearch">Search conversations</label>
        <input id="conversationSearch" type="search" class="form-control"
               placeholder="Search conversations" autocomplete="off" 
               [(ngModel)]="queryValue" (ngModelChange)="queryChange.emit($event)" />
    </div>
</div>

<div class="side-list">
    @if ( listError ) {
        <div class="empty-side">
            Your conversations could not be loaded.
            <button class="btn btn-link p-0" type="button" (click)="retryRequested.emit()">Try again</button>
        </div>
    } @else if ( groupedRows.length === 0 ) {
        <div class="empty-side">
            @if ( query.trim() !== "" ) {
                No conversations match your search.
            } @else {
                No conversations yet.<br />Start a new chat.
            }
        </div>
    } @else {
        @for ( group of groupedRows; track group.label; let groupIndex = $index ) {
            <div class="group-label" [id]="'convGroup' + groupIndex">{{ group.label }}</div>
            <ul class="conv-group" [attr.aria-labelledby]="'convGroup' + groupIndex">
            @for ( row of group.rows; track row.historyId ) {
                <li class="conv" [class.active]="row.historyId === activeId">
                    <!-- <span class="cdot" [class.it]="row.agent === 'it_support_agent'"
                         [class.student]="row.agent === 'student_support_agent'"></span> -->
                    <span>
                        @if(row.agent === 'it_support_agent'){
                            <i class="bi bi-display cicon it"></i>
                        }
                        @else if(row.agent === 'student_support_agent'){
                            <i class="bi bi-mortarboard cicon student"></i>
                        }

                    </span>

                    @if ( renamingId === row.historyId ) {
                        <span class="ctitle">
                            <label class="visually-hidden" [attr.for]="'rename_' + row.historyId">Conversation title</label>
                            <input [id]="'rename_' + row.historyId" type="text"
                                   [(ngModel)]="renameValue" (ngModelChange)="renameTextChange.emit($event)"
                                   (keyup.enter)="renameCommitted.emit()" (keyup.escape)="renameCancelled.emit()"
                                   (blur)="renameCommitted.emit()" />
                        </span>
                    } @else {
                        <button class="ctitle" type="button"
                                [title]="agentLabelFor(row.agent) + ' · ' + row.title"
                                (click)="conversationOpened.emit(row.historyId)">
                            <span class="visually-hidden">{{ agentLabelFor(row.agent) }} conversation: </span>{{ row.title }}
                        </button>
                        <button class="kebab" type="button"
                                [attr.aria-expanded]="openMenu === row.historyId"
                                [attr.aria-label]="'More options for ' + row.title"
                                (click)="menuToggled.emit({ historyId: row.historyId, event: $event })">
                            <i class="bi bi-three-dots" aria-hidden="true"></i>
                        </button>
                    }

                    @if ( openMenu === row.historyId ) {
    
                        <div class="menu" #menu>
                           <button type="button" (click)="renameStarted.emit(row)">Rename</button>
                            @if ( pendingDeleteId === row.historyId ) {
                                <button class="danger" type="button"
                                        [id]="'confirmDelete_' + row.historyId"
                                        (click)="deleteConfirmed.emit(row)">Confirm delete</button>
                            } @else {
                                <button class="danger" type="button" (click)="deleteRequested.emit(row)">Delete</button>
                            }
                        </div>
                    }
                </li>
            }
            </ul>
        }
    }
</div>
